import ExportPageFooter from './ExportPageFooter';
import { useFluidLayout } from '../layout';

export const PAGE_WIDTH_PX = 794;
export const PAGE_HEIGHT_PX = 1123;
export const PAGE_MARGIN_PX = 40;
export const FOOTER_BAND_PX = 90;
export const FOOTER_INSET_PX = 16;

export default function ExportPage({
  trip,
  tourOperator,
  settings,
  footer = true,
  footerStatus = false,
  bleed = false,
  className = '',
  children,
}) {
  const fluid = useFluidLayout();

  return (
    <div
      className={`export-page relative mx-auto overflow-hidden ${bleed ? '' : 'bg-[var(--td-paper)]'} ${className}`}
      style={
        fluid
          ? {
              width: '100%',
              maxWidth: `${PAGE_WIDTH_PX}px`,
              paddingBottom: footer ? `${FOOTER_BAND_PX}px` : undefined,
              boxSizing: 'border-box',
            }
          : {
              width: `${PAGE_WIDTH_PX}px`,
              height: `${PAGE_HEIGHT_PX}px`,
              boxSizing: 'border-box',
            }
      }
    >
      <div
        className={
          fluid ? 'relative flex flex-col' : 'absolute inset-0 overflow-hidden'
        }
        style={
          fluid
            ? { minHeight: bleed ? '100svh' : undefined }
            : { bottom: footer ? `${FOOTER_BAND_PX}px` : 0 }
        }
      >
        {children}
      </div>

      {footer && (
        <div
          className="absolute"
          style={{
            left: `${PAGE_MARGIN_PX}px`,
            right: `${PAGE_MARGIN_PX}px`,
            bottom: `${FOOTER_INSET_PX}px`,
          }}
        >
          <ExportPageFooter
            trip={trip}
            tourOperator={tourOperator}
            settings={settings}
            status={footerStatus}
          />
        </div>
      )}
    </div>
  );
}
